"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var react_1 = __importDefault(require("react"));
var Chip_1 = __importDefault(require("@material-ui/core/Chip"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("../../styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, typography = _a.typography;
    return ({
        root: {
            padding: spacing()
        },
        deleteIcon: {
            marginRight: '0 !important'
        },
        sizeSmall: {
            '& > .material-icons': {
                fontSize: typography.body1.fontSize
            }
        }
    });
});
var Chip = function (props) {
    var _a, _b, _c;
    var internalClasses = useStyles();
    return (react_1.default.createElement(Chip_1.default, __assign({ classes: __assign(__assign({}, props.classes), { sizeSmall: (0, classnames_1.default)(internalClasses.sizeSmall, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.sizeSmall), root: (0, classnames_1.default)(internalClasses.root, (_b = props.classes) === null || _b === void 0 ? void 0 : _b.root), deleteIcon: (0, classnames_1.default)(internalClasses.deleteIcon, (_c = props.classes) === null || _c === void 0 ? void 0 : _c.deleteIcon) }) }, props)));
};
exports.Chip = Chip;
